import { createSlice } from '@reduxjs/toolkit'

export const userClinicSlice = createSlice({
    name: 'userClinic',
    initialState: {
        value: undefined
    },
    reducers: {
        set: (state, action) => {
            state.value = action.payload;
        },
        unSet: state => {
            state.value = undefined;
        }
    }
})

// Action creators are generated for each case reducer function
export const { set, unSet } = userClinicSlice.actions

export default userClinicSlice.reducer